<div class="milestones-progress-overlay-footer">
  <brt-button [color]="'white'" [size]="'large'" [title]="'Schließen'" (click)="onClosed.emit()"></brt-button>
</div>
